import { render, staticRenderFns } from "./accountsReceivable.vue?vue&type=template&id=0ffa3b1e&scoped=true&"
import script from "./accountsReceivable.vue?vue&type=script&lang=js&"
export * from "./accountsReceivable.vue?vue&type=script&lang=js&"
import style0 from "./accountsReceivable.vue?vue&type=style&index=0&id=0ffa3b1e&prod&lang=scss&scoped=true&"
import style1 from "./accountsReceivable.vue?vue&type=style&index=1&id=0ffa3b1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffa3b1e",
  null
  
)

export default component.exports